export const DATA_LAYER_AFFILIATION = 'Vaxishop';

export enum DATA_LAYER_EVENTS {
  VIEW_ITEM = 'view_item',
  ADD_TO_CART = 'add_to_cart',
  VIEW_CART = 'view_cart',
  BEGIN_CHECKOUT = 'begin_checkout',
  PURCHASE = 'purchase',
  RETURN_FLU_CREDIT_SUBMIT = 'return_flu_credit_submit',
  RETURN_FLU_CREDIT_START = 'return_flu_credit_start',
  USER_REGISTRATION = 'user_registration',
  USER_LOGIN = 'login',
}

export enum DATA_LAYER_PROCESS_TYPES {
  STANDARD_PROCESS = 'standard_process',
  EDIT_RESERVATION = 'edit_reservation',
  NEW_RESERVATION = 'new_reservation',
  CONFIRM_RESERVATION = 'confirm_reservation',
}

export enum DATA_LAYER_INTERACTION_TYPES {
  ECOMMERCE = 'ecommerce',
  AUTHENTICATION = 'authentication',
}

export enum DATA_LAYER_SIGNUP_TYPES {
  NEW_USER = 'new user',
}

export enum DATA_LAYER_PRODUCT_VARIANTS {
  DOSES = 'doses',
}
